import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import { useTranslation } from "react-i18next";

import { useUnsavedChanges } from "~/providers/unsaved-changes-provider";
import { useTableStore } from "~/stores/use-table-store";
import { Button } from "../ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import TableForm from "./table-form";

export default function TableDialog() {
  const { tableDialogOpen, setTableDialogOpen, currentTable, setCurrentTable } =
    useTableStore();

  const { checkUnsavedChanges } = useUnsavedChanges();

  const { t } = useTranslation("common");

  const handleDialog = (open: boolean, force?: boolean) => {
    if (open === false) {
      if (force !== true) {
        const result = checkUnsavedChanges();
        if (result === true) {
          setTableDialogOpen(true);
          return;
        }
      }
      setCurrentTable(undefined);
    }
    setTableDialogOpen(open);
  };

  return (
    <Dialog open={tableDialogOpen} onOpenChange={handleDialog}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            {currentTable
              ? t("Table.table_x", { x: currentTable.reference })
              : t("Table.new_table")}
          </DialogTitle>
          <VisuallyHidden>
            <DialogDescription></DialogDescription>
          </VisuallyHidden>
        </DialogHeader>
        <div className="max-h-[80vh] p-4 overflow-auto small-scrollbar">
          <TableForm
            onClose={(force) => handleDialog(false, force)}
            table={currentTable}
          />
        </div>
        <DialogFooter>
          <Button
            form="table-form"
            variant="success"
            className="w-full"
            type="submit"
          >
            {currentTable ? t("Table.update") : t("Table.create")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
